const styles = () => ({
	container: {
		width: '100%',
		height: '100%',
		display: 'flex',
		flexFlow: 'column',
		alignItems: 'center',
		justifyContent: 'center'
	},
	title: {
		fontSize: '2em',
		marginTop: '2em'
	},
	'@media (min-width: 640px)': {
		title: {
			fontSize: '10em',
			marginTop: '1em'
		}
	}
});

export default styles;




// WEBPACK FOOTER //
// ./src/client/components/not-found/styles.js